import localConfig from '@/config';
import { normalizeParamsObject } from 'shared-lib/helpers/formatters';

const types = {
    SAVE_FILTERS: 'SAVE_EXTERNAL_INTEGRATIONS_FILTERS',
    RESET_FILTERS: 'RESET_EXTERNAL_INTEGRATIONS_FILTERS',
};

const initialState = {
    data: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-created',
        },
    },
};

const state = {
    ...initialState,
};


const getters = {
    externalIntegrationsFilters: state => state.data.filters,
};


const actions = {
    saveExternalIntegrationsFilters ({ commit }, payload) {
        commit(types.SAVE_FILTERS, { payload });
    },
    resetExternalIntegrationsFilters ({ commit }) {
        commit(types.RESET_FILTERS);
    },
};


const mutations = {
    [types.SAVE_FILTERS] (state, { payload }) {
        let payloadNormalized = normalizeParamsObject(payload);
        state.data = {
            ...state.data,
            filters: { ...payloadNormalized },
        };
    },
    [types.RESET_FILTERS] (state) {
        state.data.filters = { ...initialState.data.filters };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
